import React, { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { ChevronDown } from 'lucide-react'
import Container from './Container'

const faqs = [
  {
    question: '¿Puedo agendar cita presencial en Madrid o virtual?',
    answer: 'Sí. Estaremos presencialmente en IFEMA Madrid del 20 al 23 de mayo de 2026. Si no puedes asistir, ofrecemos la opción de agendar una videollamada para revisar los proyectos.'
  },
  {
    question: '¿Qué incluye la reunión?',
    answer: 'Una asesoría 1:1 donde evaluamos tu objetivo, presupuesto y timing para presentarte las mejores opciones entre ORIÓN y FOREST, explicando el mercado de Punta Cana sin compromisos.'
  },
  {
    question: '¿Cuáles son los montos de reserva?',
    answer: 'Los montos varían según el proyecto: FOREST desde US$2,000 y ORIÓN desde US$5,000. Durante la cita te explicaremos el plan de pago y las facilidades disponibles.'
  },
  {
    question: '¿Cómo se comparan ORIÓN y FOREST según lo que busco?',
    answer: 'Dependerá de si buscas inversión pura, renta vacacional o segunda vivienda. ORIÓN destaca por su diseño en Costa Bávaro, y FOREST por su concepto de comunidad completa con múltiples amenidades.'
  },
  {
    question: '¿Qué pasos siguen después de separar una unidad?',
    answer: 'Te guiamos en la firma del contrato de promesa de compraventa, revisión de documentos legales y coordinación de los pagos durante la construcción hasta la entrega final de tu propiedad.'
  }
]

const FAQItem: React.FC<{ question: string; answer: string; index: number }> = ({ question, answer, index }) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-50px' }}
      transition={{ duration: 0.4, delay: index * 0.1 }}
      className="border-b border-border-light last:border-0"
    >
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex w-full items-center justify-between py-6 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-accent rounded-lg px-2"
        aria-expanded={isOpen}
      >
        <span className="font-display text-lg font-bold text-primary md:text-xl pr-8">
          {question}
        </span>
        <ChevronDown
          className={`h-5 w-5 flex-shrink-0 text-accent transition-transform duration-300 ${
            isOpen ? 'rotate-180' : ''
          }`}
        />
      </button>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="overflow-hidden"
          >
            <p className="pb-6 text-text-secondary px-2">{answer}</p>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  )
}

const FAQSectionSima: React.FC = () => {
  return (
    <section className="bg-white py-24 md:py-32">
      <Container size="md">
        <div className="mb-16 text-center">
          <span className="mb-4 inline-block font-medium text-accent uppercase tracking-widest text-sm">
            Dudas Comunes
          </span>
          <h2 className="font-display text-3xl font-bold text-primary md:text-4xl lg:text-5xl mb-6">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="rounded-2xl bg-background-alt p-6 md:p-8 lg:p-12 shadow-sm border border-border-light">
          {faqs.map((faq, index) => (
            <FAQItem key={index} index={index} question={faq.question} answer={faq.answer} />
          ))}
        </div>
      </Container>
    </section>
  )
}

export default FAQSectionSima
